<template>
    <paper class='bill'>
        <m-pane
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="listLoading"
            :currentPage="currentPage"
            :initSearchInfo="initSearchInfo"
            searchId="billQuery"
            pageID="statement"
            @row-db-click="rowDBclick"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange">
            <div slot="table-module-btn"></div>
        </m-pane>
    </paper>
</template>

<script>
import mPane from '@/components/supplierPanel';
import paper from '@/components/core/paper/Paper';
import config from './config.js';
import { getApDealingsBillList } from '../../../api/statement/statementApi';
import common from '../../../common/common';
import formatTime from '@/utils/common.js';
import { mapGetters } from 'vuex';
const { initSessionData } = common;
export default {
    name: 'statementIndex',
    components: { mPane, paper },
    data() {
        return {
            initSearchInfo: {}, // 用于设置初始默认值
            currentPage: 1,
            searchQuery: {},
            page: {
                pageSize: config.page.pageSize,
                pageNo: config.page.pageNo
            },
            pageTotal: 0,
            totalData: [],
            listLoading: false,
            accountMode: '',
            config
        };
    },
    computed: {
        ...mapGetters(['supplier'])
    },
    activated() {
        if (this.$route.query.dealingsBillStatus && this.$route.query.accountMode) {
            this.initRouter();
        }
    },
    methods: {
        initRouter() {
            if (this.$route.query.dealingsBillStatus && this.$route.query.accountMode) {
                this.initSearchInfo = {
                    dealingsBillStatuses: this.$route.query.dealingsBillStatus.split(',')
                };
                this.accountMode = this.$route.query.accountMode;
                this.$router.replace({ path: this.$route.path, query: {} });
                this.$nextTick(() => {
                    this.$refs.tablePage.$refs.searchList.onSearchChange();
                });
            }
        },
        searchChange(data) {
            this.page.pageNo = 1;
            data.endAccountCycle = data.endAccountCycle ? formatTime.formatDateMonth(data.endAccountCycle) : '';
            this.searchQuery = data;
            this.loadData();
        },
        pageChange(data) {
            this.page.pageNo = data;
            this.loadData();
        },
        sizeChange(data) {
            config.page.pageSize = this.page.pageSize = data;
            this.loadData();
        },
        /** 加载表格数据 */
        loadData() {
            const params = {
                pageNo: this.page.pageNo,
                pageSize: this.page.pageSize,
                isManage: 0,
                isSup: 1,
                isOrder: 1,
                supCode: this.supplier.supplierCode,
                ...this.searchQuery
            };
            if (this.accountMode) {
                params.accountMode = this.accountMode;
            }
            if (params.dealingsBillStatuses) {
                params.dealingsBillStatuses = params.dealingsBillStatuses.toString();
            }
            this.listLoading = true;
            this.$refs.tablePage.$refs.searchList.changeLoading(true);
            getApDealingsBillList(params).then(res => {
                if (res && +res.code === 0) {
                    this.totalData = res.data.list || [];
                    this.pageTotal = res.data.totalCount || 0;
                    this.transData(this.totalData);
                }
            }).finally(() => {
                this.listLoading = false;
                this.accountMode = '';
                this.$refs.tablePage.$refs.searchList.changeLoading(false);
            });
        },
        /** 数据转化 */
        transData(array) {
            array.forEach(item => {
                item.dealingsAccountResult = item.dealingsAccountResult && item.dealingsAccountResult + '';
                item.dealingsBillStatus = item.dealingsBillStatus && item.dealingsBillStatus + '';
            });
        },
        rowDBclick(val) {
            this.$router.push({ path: `/bms/statementDetails`, query: { dealingsBillNo: val.dealingsBillNo } });
        },
        selectChange() {}
    },
    mounted() {
        initSessionData(['SYS_DEALINGS_BILL_STATUS', 'BMS_ACCOUNT_PATTERN', 'SYS_DEALINGS_ACCOUNT_RESULT']);
        if (this.$route.query.from === 'todoList') {
            this.initRouter();
        } else {
            this.$refs.tablePage.$refs.searchList.onSearchChange();
        }
    }

};
</script>

<style lang="less">
</style>
